import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { FormResponse, FormId, CompactFormResponse } from '@business/entities/form';
import { pipeIf } from '@core/utils/rxjs/operators';
import { SubContractorCategoryFormAPI } from '@business/api/subcontractorCategoryForm';

export class SubContractorCategoryFormBloc extends BaseBloc {
  private readonly formRepo = new Repository<FormResponse | CompactFormResponse>({
    getItemId: form => form.id,
  });

  readonly forms$ = this.formRepo.items$;
  readonly selectForm = this.formRepo.selectItem;

  onReset() {
    this.formRepo.reset();
  }

  fetchForms = (fullResponse = false) => {
    return SubContractorCategoryFormAPI.fetchForms(fullResponse).pipe(this.formRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_form_error') }));
  };
  fetchTabForm = () => {
    return SubContractorCategoryFormAPI.fetchTabForm().pipe(handleMessage({ error: requestMessage('fetch_form_error') }));
  };

  fetchForm = (id: FormId) => {
    return SubContractorCategoryFormAPI.fetchForm(id).pipe(
      this.formRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_form_error') }),
    );
  };

  createForm = (data: Partial<FormResponse>) => {
    return SubContractorCategoryFormAPI.createForm(data).pipe(
      this.formRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_form'),
      }),
    );
  };

  updateForm = (id: FormId, data: Partial<FormResponse>) => {
    return SubContractorCategoryFormAPI.updateForm(id, data).pipe(
      this.formRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_form'),
      }),
    );
  };

  deleteForm = (id: FormId) => {
    return showDeleteConfirmation('Delete Form', 'Do you really want to remove this form?').pipe(
      switchMap(() => SubContractorCategoryFormAPI.deleteForm(id)),
      this.formRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_form'),
      }),
    );
  };

  duplicateForm = (id: FormId, form: Partial<FormResponse>) => {
    return SubContractorCategoryFormAPI.duplicateForm(id, form).pipe(
      this.formRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('clone_form'),
      }),
    );
  };

  saveFormFields = (id: FormId, data: Pick<FormResponse, 'fields'>, message = true) => {
    return SubContractorCategoryFormAPI.saveFormFields(id, data).pipe(

      this.formRepo.ops.upsertOne(item => ({ item })),
      pipeIf(
        message &&
        handleMessage({
          type: requestMessage('save_form_fields'),
        }),
      ),
    );
  };

  deleteFormShare = (id: string) => {
    return SubContractorCategoryFormAPI.deleteFormShare(id);
  };
}
